export { P, A, Span, H1, H2, H3, H4, H5, H6 } from './Typography';
